import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  statistics: {},
};

const showPopupStatisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    // Додає групу
    addStatisticsRedux(state, { payload }) {
      state.statistics = payload;
      // console.log(payload);
    },
    deleteStatisticsRedux(state) {
      state.statistics = {};
      // console.log(payload);
    },
  },
});

export const { addStatisticsRedux, deleteStatisticsRedux } = showPopupStatisticsSlice.actions;

export default showPopupStatisticsSlice.reducer;
